import { render, staticRenderFns } from "./FloatingActionButtons.vue?vue&type=template&id=c2515728&scoped=true&"
import script from "./FloatingActionButtons.vue?vue&type=script&lang=js&"
export * from "./FloatingActionButtons.vue?vue&type=script&lang=js&"
import style0 from "./FloatingActionButtons.vue?vue&type=style&index=0&id=c2515728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2515728",
  null
  
)

export default component.exports